import { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from "../../../shared/datatable/Datatable";
import { MoreIcon, UserPlusIcon } from "../../../shared/icons/Icons";
import { clientsList, clientMetrics } from "../../../shared/settings/apiConfig";
import { getApi } from "../../../shared/services/apiHelper";
import { CLIENT_METRICS } from "../../../shared/utils/constants";
import { formatCurrency } from "../../../shared/utils/formatCurrency";

import '../home/Dashboard.scss';

export default function ClientList (props) {

    const customEdit = (row) => {
        return (
            <div className="clickable" onClick={(e) => { e.stopPropagation(); setActionModal({ show: true, target: e.target, row: row });}}>
                <MoreIcon />
            </div>
        );
    };

    const dataTable = useRef(null);
    const [metrics, setMetrics] = useState(CLIENT_METRICS);
    const [search, setSearch] = useState("");
    const [status] = useState("");
    const [, setActionModal] = useState({ show: false, target: null, row: null });

    const [config] = useState({
        name: 'clients',
        url: clientsList,
        columns: [
            { name: 'ClientName', sort: false, width: '25%' },
            { name: 'Contact', sort: false, width: '20%' },
            { name: 'Age/Gender', sort: false, width: '15%' },
            { name: 'Last Activity', property: 'created_at', sort: true, width: '20%' },
            { name: 'Actions', property: '', width: '10%', customColumn: customEdit }
        ],
        field: ['id', 'name', 'email', 'mobile', 'company_name', 'created_at', 'is_deleted'],
        filter: [{ "field": "is_deleted", "value": false, "op": "=", "join": "AND" }],
        sort: [{ "field": "created_at", "direction": "desc" }],
        pagination: true,
        editLink: "/clients/edit/"
    });

    useEffect(() => {
        getApi(clientMetrics).then(response => {
            const data = response.data;
            if (data) {
                setMetrics(prevState => {
                    return prevState.map(metric => {
                        const key = metric.key;
                        const value = data[key];
                        return { ...metric, value: value !== undefined ? value : metric.value };
                    });
                });
            }
        }).catch(error => {
            console.log("Failed to fetch client metrics:", error);
        });
    }, []);

    useEffect(() => {
        if (search || status) {
            let filters = [];

            if (search?.trim()) {
                filters.push(
                    { field: 'firstname', value: search, op: 'LIKE', join: 'OR' },
                    { field: 'lastname', value: search, op: 'LIKE', join: 'OR' },
                    { field: 'company_name', value: search, op: 'LIKE', join: 'OR' },
                    { field: 'email', value: search, op: 'LIKE', join: 'OR' },
                    { field: 'mobile', value: search, op: 'LIKE', join: 'OR' }
                );
            }
            if (status) {
                filters.push(
                    { field: 'isactive', value: status === 'Active' ? '1' : status === 'InActive' ? '0' : '', op: 'LIKE', join: 'OR' }
                );
            }

            if (filters.length) {
                dataTable.current.searchData(filters);
            } else {
                clearData();
            }
        } else {
            clearData();
        }
    }, [search, status]);

    const navigateToClient = () => {
        props.history.push('/clients/add');
    }

    const clearData = () => {
        setSearch("");
        dataTable.current?.searchData([]);
    }

    return(
        <div className="assignment-list main-content animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex flex-column">
                    <h3 className="content-label">Clients</h3>
                    <p className='content-sub-label fw-bold text-gray'>Manage your clients and their projects</p>
                </div>
                <div className="d-flex gap-3">
                     <div className="btn btn-solid-blue fw-bold" onClick={() => { navigateToClient() }}><UserPlusIcon /> Add Client</div>

                </div>
            </div>

            <div className="metrics-row">
                {
                    metrics.map((metric, index) => (
                        <div className="metric-card-view d-flex align-items-center gap-3 flex-grow-1" key={"metric-" + index}>
                            <div className={`metric-icon ${metric.label === "Total Clients" ? "summary-icon-purple2" : metric.label === "Total Projects" ? "summary-icon-blue" : metric.label === "Total Value" ? "summary-icon-green" : "summary-icon-purple"}`}>
                                <metric.icon />
                            </div>
                            <div className="content">
                                <div className="fw-bold text-gray text-n">{metric.label}</div>
                                <div className="font-weight-bold text-2l">
                                    {metric.key === "totalvalue" ? formatCurrency(metric.value) : metric.value}
                                </div>
                                {metric.description ? <div className="description">{metric.description}</div> : ''}
                            </div>
                        </div>
                    ))
                }
            </div>

            <div className="activity-card user-input-section d-flex mt-3 p-3 gap-3">
                <InputGroup className="p-0 rounded">
                    <InputGroupText className="search" style={{ position: 'static' }} >
                        <i className="fa fa-search ml-3" ></i>
                    </InputGroupText>

                    <span className="icon-envelope-o"></span>
                    <Form.Control className={`search `} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"Search clients by name, company, email or phone..."}
                        onChange={(event) => { setSearch(event.target.value) }}
                        value={search} />
                </InputGroup>
            </div>

            <Datatable ref={dataTable} config={config} viewType={'grid'} props={props} history={props.history} />
        </div>
    )
}
